import React from 'react';
import { Form } from 'react-bootstrap';
import CreatableSelect from "react-select/creatable";
import { IOptionType } from "../../types/common";
import { MultiValue } from "react-select";
import { FilterPopover } from "../../components";

interface IImagesManualFilterProps {
    manufacturerOptions: IOptionType[];
    selectedManufacturers: IOptionType[];
    onChangeManufacturers: (items: MultiValue<IOptionType>) => void;
    t: (key: string) => string;
    handleApplyFilter: (event: React.FormEvent) => void;
    isLoading: boolean;
}

const ImagesManualSelectionFilter: React.FC<IImagesManualFilterProps> = ({
    manufacturerOptions: manufacturers,
    selectedManufacturers: selectedManufacturerOptions,
    onChangeManufacturers,
    isLoading,
    handleApplyFilter,
    t
}) => (
    <FilterPopover
        id="images-manual-selection-filter"
        title={t("OnlyMatchToOEM.FilterTitle")}
        isLoading={isLoading}
        onApplyFilter={handleApplyFilter}
        t={t}
    >
        <Form.Group>
            <Form.Label>{t("Filter.manufacturer")}(s)</Form.Label>
            <CreatableSelect
                className="card border-0 d-md-block"
                closeMenuOnSelect={false}
                isMulti
                isDisabled={isLoading}
                options={manufacturers}
                defaultValue={selectedManufacturerOptions}
                placeholder={t("Filter.manufacturer")}
                isSearchable
                onChange={(items) => onChangeManufacturers(items)}
            />
        </Form.Group>
    </FilterPopover>
)

export default ImagesManualSelectionFilter;
